<template>
  <div style="padding: 0 10px">
    <PrintTemplate></PrintTemplate>
  </div>
</template>
<script>
import PrintTemplate from "@/components/PrintTemplate/index.vue";
import { printList,savePrint } from "@/apis/configure" 

export default {
  title: "标签模板",
  name: "ConfigureAddTemplate",
  data(){
    return {}
  },
  components: {
    PrintTemplate,

  },
  methods:{
    handleClose(){
      this.dialogVisible=!this.dialogVisible;
    }
  }
};
</script>

<style scoped></style>
